export enum ClientTypes {
    'launchdarkly' = 'LAUNCHDARKLY',
    'evidently' = 'EVIDENTLY',
}

export interface Client {
    configure: (config: unknown) => void;
    getFlagValue: (key: string, defaultValue?: unknown, evaluationContext?) => Promise<unknown>;
}
